module.exports = "/shifts/components/shiftSlotsComponent-81b6dc.html";